<mat-expansion-panel class="mat-elevation-z1" [expanded]="expanded">
  <mat-expansion-panel-header style="background-color: whitesmoke;">
    <mat-panel-title class="avenir-font text-nowrap">
      {{this.label}}
    </mat-panel-title>
    <mat-panel-description class="justify-content-end">
      <mat-icon [ngStyle]="{'color': items.length > 0 ? '#9E81E4' : '#999'}">{{iconName}}</mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="pt-4">
    <mat-form-field class="w-100" appearance="fill" subscriptSizing="dynamic" floatLabel="always">
      <mat-label class="avenir-font">{{ label }}</mat-label>
      <mat-chip-grid #chipList>
        <!-- Показываем троеточие, если элементов больше 5 -->
        <ng-container *ngIf="items.length > 5">
          <mat-chip (click)="$event.stopPropagation(); tagsShowMore()"><small>+{{items.length - 5}} more...</small></mat-chip>
        </ng-container>

        <!-- Отображаем последние 5 элементов -->
        <ng-container *ngFor="let item of items.slice(-5)">
          <mat-chip [removable]="true" (removed)="remove(item)" class="custom-chip">
            <small *ngIf="this.searchField == 'website'" class="avenir-font">{{ item | truncate:30 }}</small>
            <small *ngIf="this.searchField != 'website'" class="avenir-font">{{ item | titlecase |truncate:30 }}</small>
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </ng-container>

        <input #input
          placeholder="{{ placeholder }}"
          [formControl]="inputControl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputAddOnBlur]="addOnBlur">
        <mat-spinner color="primary" diameter="20" *ngIf="loading"></mat-spinner>
      </mat-chip-grid>

      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event); input.value = ''">
        <mat-option *ngFor="let item of filteredItems | async" [value]="item" class="mt-2 mb-2">
          <div class="d-flex align-items-center">
            <clearbit-logo *ngIf="this.searchField == 'companyName'" [domain]="item?.website" [height]="25" [width]="25"></clearbit-logo>
            <clearbit-logo *ngIf="this.searchField == 'website'" [domain]="item?.name" [height]="25" [width]="25"></clearbit-logo>
            <small *ngIf="this.searchField == 'website'" class="avenir-font">{{ item.name }}</small>
            <small *ngIf="this.searchField != 'website'" class="avenir-font">{{ item.name | titlecase }}</small>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</mat-expansion-panel>
